export default __webpack_public_path__ + "47031585f3ac3ccc60ca5ec93c1f3889.svg";